import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useSWR from "swr";
import { fetchData } from "../../../lib/dashboard/data";
import { Box, Skeleton, TableContainer, Typography } from "@mui/material";
import NotFound from "../../../components/notfound/NotFound";

export default function TopOptions() {
  const { data = [], isLoading } = useSWR("/dashboard/top-options", fetchData, {
    revalidateOnFocus: false,
    dedupingInterval: 60 * 1000,
  });

  return (
    <Paper sx={{ height: "100%" }}>
      <Typography sx={{ mb: 2, fontWeight: 700 }}>بیشترین ارزش معاملات </Typography>
      {data.length < 1 ? (
        <Box sx={{ height: "100%" }}>
          <NotFound />
        </Box>
      ) : (
        <TopOptionsTable data={data} isLoading={isLoading} />
      )}
    </Paper>
  );
}

const TopOptionsTable = ({ data, isLoading }) => {
  const cols = Object.values({
    symbol: "نماد",
    total_value: "ارزش کل",
    best_call: "کال",
    call_value: "ارزش کال",
    best_put: "پوت",
    put_value: "ارزش پوت",
  });

  return (
    <TableContainer sx={{ overflow: "auto" }}>
      <Table size="small" sx={{ tableLayout: "auto", whiteSpace: "nowrap" }}>
        <TableHead>
          <TableRow>
            {cols.map((col) => (
              <TableCell
                sx={{
                  fontWeight: 700,
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
                key={col}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading
            ? [...Array(5)].map((_, index) => (
              <TableRow key={index}>
                {[...Array(6)].map((_, i) => (
                  <TableCell
                    key={i}
                    sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                  >
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            ))
            : data.map((item) => (
              <TableRow key={item.symbol}>
                <TableCell sx={{ textAlign: "center" }}>
                  {item.symbol}
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {item.total_value}
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {item.best_call}
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {item.call_value}
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {item.best_put}
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {item.put_value}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
